import icon360Negocios from "../../../../../../../assets/images/empresa/sobre-nos/premios/360negocios.png";
import icon500Grandes from "../../../../../../../assets/images/empresa/sobre-nos/premios/500grandes.png";
import iconBrazilNetwork from "../../../../../../../assets/images/empresa/sobre-nos/premios/brazilNetwork.png";
import iconEticaNosNegocios from "../../../../../../../assets/images/empresa/sobre-nos/premios/eticaNosNegocios.png";
import iconExame from "../../../../../../../assets/images/empresa/sobre-nos/premios/exame.png";
import iconHuawei from "../../../../../../../assets/images/empresa/sobre-nos/premios/huawei.png";
import iconIbef from "../../../../../../../assets/images/empresa/sobre-nos/premios/ibef.png";
import iconIot from "../../../../../../../assets/images/empresa/sobre-nos/premios/iot.png";
import iconMinasEmpresarial from "../../../../../../../assets/images/empresa/sobre-nos/premios/minasEmpresarial.png";
import iconMinisterioPublico from "../../../../../../../assets/images/empresa/sobre-nos/premios/ministerioPublico.png";
import iconParceriaPelaVida from "../../../../../../../assets/images/empresa/sobre-nos/premios/parceriaPelaVida.png";
import iconPremioSerHumano from "../../../../../../../assets/images/empresa/sobre-nos/premios/premioSerHumano.png";
import iconTelecom from "../../../../../../../assets/images/empresa/sobre-nos/premios/telecom.png";
import iconTopEngenharia from "../../../../../../../assets/images/empresa/sobre-nos/premios/topEngenharia.png";
import iconValor1000 from "../../../../../../../assets/images/empresa/sobre-nos/premios/valor1000.png";
import iconZte from "../../../../../../../assets/images/empresa/sobre-nos/premios/zte.png";

export interface Premio {
  nome: string;
  icone?: string;
}

export type PremiosPorAno = Record<number, Premio[]>;

export const premiosPorAno: PremiosPorAno = {
  2007: [{ nome: "• Valor 1000 Construção e Engenharia", icone: iconValor1000 }],
  2009: [{ nome: "• 500 Grandes da Construção - Revista O Empreiteiro", icone: icon500Grandes }],
  2010: [{ nome: "• 500 Grandes da Construção - Revista O Empreiteiro", icone: icon500Grandes }],
  2011: [
    { nome: "• Anuário Telecom - Destaque do Ano", icone: iconTelecom },
    { nome: "• Best Delivery Partner - ZTE do Brasil", icone: iconZte },
    { nome: "• Ética nos Negócios", icone: iconEticaNosNegocios },
  ],
  2012: [
    { nome: "• 500 Grandes da Construção - Revista O Empreiteiro", icone: icon500Grandes },
    { nome: "• Instituto Brasileiro de Executivos de Finanças de Minas Gerais (IBEF-MG)", icone: iconIbef },
  ],
  2013: [{ nome: "• Minas Desempenho Empresarial", icone: iconMinasEmpresarial }],
  2014: [
    { nome: "• Minas Desempenho Empresarial", icone: iconMinasEmpresarial },
    { nome: "• Top Engenharias MG", icone: iconTopEngenharia },
  ],
  2015: [
    {
      nome: "• Ministério Público do Trabalho - Inclusão de Pessoas com Deficiência no Mercado de Trabalho",
      icone: iconMinisterioPublico,
    },
  ],
  2016: [{ nome: "• IOT Partner of the Year - Cisco Brasil e Latam", icone: iconIot }],
  2017: [
    { nome: "• Brazil Networking Partner of the Year - HPE Aruba", icone: iconBrazilNetwork },
    {
      nome: "• Parceria pela Vida - Segurança do Trabalho e Responsabilidade Social",
      icone: iconParceriaPelaVida,
    },
  ],
  2018: [
    { nome: "• Best Support for New Business - Huawei", icone: iconHuawei },
    { nome: "• Época Negócios 360", icone: icon360Negocios },
  ],
  2019: [
    { nome: "• Anuário Telecom - Destaque do Ano", icone: iconTelecom },
    { nome: "• Minas Desempenho Empresarial", icone: iconMinasEmpresarial },
    { nome: "• Prêmio Ser Humano ABRH-MG", icone: iconPremioSerHumano },
    { nome: "• Revista Exame - 1000 Melhores e Maiores Empresas do Brasil", icone: iconExame },
    { nome: "• Valor 1000 Construção e Engenharia", icone: iconValor1000 },
  ],
  2020: [
    { nome: "• Anuário Telecom - Destaque do Ano", icone: iconTelecom },
    { nome: "• Minas Desempenho Empresarial", icone: iconMinasEmpresarial },
    { nome: "• Prêmio Ser Humano ABRH-MG", icone: iconPremioSerHumano },
    { nome: "• Época Negócios 360", icone: icon360Negocios },
  ],
  2021: [
    { nome: "• Anuário Telecom - Destaque do Ano", icone: iconTelecom },
    { nome: "• Minas Desempenho Empresarial", icone: iconMinasEmpresarial },
    { nome: "• Prêmio Ser Humano ABRH-MG", icone: iconPremioSerHumano },
    { nome: "• Valor 1000 Construção e Engenharia", icone: iconValor1000 },
  ],
  2022: [
    { nome: "• Minas Desempenho Empresarial", icone: iconMinasEmpresarial },
    { nome: "• Prêmio Ser Humano ABRH-MG", icone: iconPremioSerHumano },
  ],
  2024: [{ nome: "• Prêmio Ser Humano ABRH-MG", icone: iconPremioSerHumano }],
  2025: [{ nome: "• Prêmio Ser Humano ABRH-MG", icone: iconPremioSerHumano }],
};

const anosOrdenados = Object.keys(premiosPorAno)
  .map(Number)
  .sort((a, b) => a - b);

export function getAnosPorColuna(numColunas: number = 3): number[][] {
  const total = anosOrdenados.length;
  const baseSize = Math.floor(total / numColunas);
  const remainder = total % numColunas;
  const colunas: number[][] = [];
  let start = 0;
  for (let c = 0; c < numColunas; c++) {
    const size = baseSize + (c < remainder ? 1 : 0);
    colunas.push(anosOrdenados.slice(start, start + size));
    start += size;
  }
  return colunas.filter((col) => col.length > 0);
}
